import useSEO from "../hooks/useSEO";
import Hero from "../sections/Hero";
import VideoFeature from "../sections/VideoFeature";
import LogoMarquee from "../sections/LogoMarquee";
import HomeStats from "../sections/HomeStats";
import FeaturedProductions from "../sections/FeaturedProductions";
import HomeServices from "../sections/HomeServices";
import HomeCTA from "../sections/HomeCTA";

export default function Home() {
  useSEO({
    title: "Premium Film, Music & Live Experiences",
    description:
      "Ideal Entertainment is a global production house creating original films, music and immersive live experiences with world-class artists and brands.",
  });
  return (
    <>
      <Hero />
      <VideoFeature />
      <LogoMarquee />
      <HomeStats />
      <FeaturedProductions />
      <HomeServices />
      <HomeCTA />
    </>
  );
}
